import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	aiEnabledMiniTitle: {
		id: 'issue-create.common.ai-enabled.ai-enabled-title.ai-enabled-mini-title',
		defaultMessage: 'Suggestion preview',
		description:
			'Title text for AI mini modal. This message is not yet finalised and will not be translated until the nonfinal suffix is removed from the message id',
	},
});
